import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import laCasera from "../images/la-casera-Logo.png";
import drinkware from "../images/drinkaware.png";
import footDesk from "../images/footerDesk.jpg";
import footMob from "../images/contactfooterMob.jpg";
import crack from "../images/crackLacasera.png";
import bg from "../images/contactDesk.jpg";
import bgMob from "../images/contactMob.jpg";
//import { TbCaretUpDownFilled } from "react-icons/tb";
//import ReCAPTCHA from "react-google-recaptcha";
import AgeVerification from "../components/AgeVerification"; // Adjust the path as needed

import "../App.css";

const Contact = () => {
  //const recaptchaRef = useRef();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  //const [isChecked, setIsChecked] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const [footImage, setFootImage] = useState(
    window.innerWidth < 904 ? footMob : footDesk
  );

  const [contactImage, setContactImage] = useState(
    window.innerWidth < 904 ? bgMob : bg
  );

  /// Form state - Holds the data for all form fields
  // const [formData, setFormData] = useState({
  //   reason: "",
  //   isSupplier: false,
  //   firstName: "",
  //   lastName: "",
  //   Title: "",
  //   Email: "",
  //   contact_number: "",
  //   house_no_street: "",
  //   city: "",
  //   postcode: "",
  //   Flavour: "",
  //   Size: "",
  //   Where: "",
  //   batchCode: "",
  //   Month: "",
  //   Year: "",
  //   BusinessName: "",
  //   Comments: "",
  //   Kept: "",
  // });

  // State to hold the file input fields - Default values are "No file chosen"
  // const [selectedFiles, setSelectedFiles] = useState({
  //   fileUpload1: "No file chosen", // For the first file input
  //   fileUpload2: "No file chosen", // For the second file input
  // });

  // Handle input field changes (for form fields like text, email, etc.)
  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;

  //   setFormData((prev) => {
  //     let updatedForm = {
  //       ...prev,
  //       [name]: type === "checkbox" ? checked : value,
  //     };

  //     // If Kept is changed to "YES-NO-CODE" or "NO", clear batch-related fields
  //     if (name === "Kept" && (value === "YES-NO-CODE" || value === "NO")) {
  //       updatedForm = {
  //         ...updatedForm,
  //         batchCode: "",
  //         Month: "",
  //         Year: "",
  //       };
  //     }

  //     return updatedForm;
  //   });
  // };

  // Handle file input changes (when a file is uploaded)
  // const handleFileChange = (event) => {
  //   const { id } = event.target; // Get the ID of the input field (fileUpload1 or fileUpload2)
  //   const files = Array.from(event.target.files); // Convert the file list to an array

  //   // Check if files exceed size or have unsupported type
  //   files.forEach((file) => {
  //     if (file.size > 5 * 1024 * 1024) {
  //       alert("File size exceeds 5MB limit");
  //       return;
  //     }
  //     if (!["image/png", "image/jpeg", "image/gif"].includes(file.type)) {
  //       alert(
  //         "Invalid file type. Please upload a .png, .jpg, .jpeg, or .gif file."
  //       );
  //       return;
  //     }
  //   });

  //   // Update the state with the new file names (or "No file chosen" if nothing is selected)
  //   setSelectedFiles((prevFiles) => ({
  //     ...prevFiles, // Spread the previous state
  //     [id]:
  //       files.length > 0 // If files are uploaded, show the file names
  //         ? files.map((file) => file.name).join(", ") // Join multiple files with a comma
  //         : "No file chosen", // If no file is chosen, display the default text
  //   }));
  // };

  // Helper function to convert a file to Base64
  // const toBase64 = (file) =>
  //   new Promise((resolve, reject) => {
  //     const reader = new FileReader(); // Create a FileReader to read the file
  //     reader.readAsDataURL(file); // Start reading the file as a data URL (Base64)
  //     reader.onload = () => resolve(reader.result); // Resolve the promise with the Base64 result
  //     reader.onerror = (error) => reject(error); // Reject the promise if there's an error
  //   });

  // Handle form submission
  // const handleSubmit = async (event) => {
  //   event.preventDefault(); // Prevent the default form submission behavior
  //   const captchaValue = recaptchaRef.current.getValue(); // Get the reCAPTCHA value

  //   // If reCAPTCHA is not verified, show an alert and stop submission
  //   if (!captchaValue) {
  //     alert("Please verify the reCAPTCHA!");
  //     return;
  //   }

  //   // Convert files to Base64 (necessary for sending files in a form submission)
  //   const fileData = await Promise.all(
  //     Object.keys(selectedFiles).map(async (key) => {
  //       const input = document.getElementById(key); // Get the file input field by ID
  //       const files = Array.from(input.files); // Get all selected files

  //       // Convert files to Base64
  //       const convertedFiles = await Promise.all(
  //         files.map(async (file) => {
  //           const base64 = await toBase64(file); // Convert each file to Base64
  //           return { name: file.name, content: base64 }; // Return file name and Base64 content
  //         })
  //       );
  //       return convertedFiles; // Return the resolved file data
  //     })
  //   );

  //   const finalFileData = fileData.flat(); // Flatten the file array in case of multiple inputs

  //   // Combine form data and file data into one object
  //   const finalData = {
  //     ...formData, // Include form data
  //     files: finalFileData.length > 0 ? finalFileData : null, // Include file data if present
  //   };

  //   //console.log("Converted File Data:", fileData);

  //   // Log the final data to the console for debugging
  //   console.log("📌 Full Form Data Before Sending:", finalData);

  //   try {
  //     // Send the final data to a Netlify function that will handle Salesforce submission
  //     const response = await fetch("/.netlify/functions/submitToSalesforce", {
  //       method: "POST", // Use POST method to send the data
  //       headers: { "Content-Type": "application/json" }, // Set the request headers to indicate JSON content
  //       body: JSON.stringify(finalData), // Convert the final data object into a JSON string
  //     });

  //     const result = await response.json(); // Parse the response from the Netlify function
  //     console.log("✅ Salesforce Response:", result); // Log the response from Salesforce
  //     alert("Form submitted successfully!"); // Show a success alert

  //     // Reset form data and file input after successful submission
  //     setFormData({
  //       reason: "",
  //       isSupplier: false,
  //       firstName: "",
  //       lastName: "",
  //       Title: "",
  //       Email: "",
  //       contact_number: "",
  //       house_no_street: "",
  //       city: "",
  //       postcode: "",
  //       Flavour: "",
  //       Size: "",
  //       Where: "",
  //       batchCode: "",
  //       Month: "",
  //       Year: "",
  //       BusinessName: "",
  //       Comments: "",
  //       Kept: "",
  //     });

  //     setSelectedFiles({
  //       fileUpload1: "No file chosen",
  //       fileUpload2: "No file chosen",
  //     });

  //     // Reset ReCAPTCHA state
  //     recaptchaRef.current.reset();
  //   } catch (error) {
  //     console.error("❌ Form Submission Error:", error); // Log any errors to the console
  //     alert("Submission failed."); // Show a failure alert
  //   }

  //   // Reset checkbox
  //   setIsChecked(false);
  // };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 904) {
        setFootImage(footMob);
        setContactImage(bgMob);
      } else {
        setFootImage(footDesk);
        setContactImage(bg);
      }
    };

    // Listen for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove event listener when component unmounts
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const isVerified = localStorage.getItem("ageVerified");
    if (isVerified) {
      setIsVerified(true);
    }
  }, []);

  if (!isVerified) {
    return <AgeVerification onVerify={() => setIsVerified(true)} />;
  }

  return (
    <div className="bg-[#282728] h-[100%]">
      {/* Navigation bar////////////////////////////////////////////////////////////////////////////////// */}
      <div className="mx-auto max-w-[1440px] x904:h-[128px] absolute w-full z-10 left-1/2 translate-x-[-50%] flex items-center justify-between">
        {/* Reload page --------------*/}
        <Link to="/" className="cursor-pointer">
          <img
            src={laCasera}
            className=" cursor-pointer z-20 x904:mt-6 sms:mt-6 sm:mt-6 mob2:mt-6 xs:mt-4 x904:ml-12 xs:ml-[20%]  x904:w-[125px]  sms:w-[180px] sm:w-[145px] mob2:w-[100px]  xs:w-[80px]  "
            alt="logo"
          />
        </Link>

        {/* Burger SVG (conditionally rendered based on screen width) */}
        <svg
          onClick={toggleMenu}
          className=" z-20 x904:hidden ml-4 sms:h-16 sms:w-16 sm:w-14 sm:h-14 mob2:w-10 mob2:h-10 xs:w-8 xs:h-8 mr-[5%]"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className={`transition-transform  ${
              isMenuOpen
                ? " -rotate-45 translate-y-2 -translate-x-[0.5rem]"
                : ""
            }`}
            d="M4 14L20 14"
            stroke="#fedd00"
            strokeWidth="1"
            strokeLinecap="round"
          />
          <path
            className={`transition-transform ${isMenuOpen ? "opacity-0 " : ""}`}
            d="M4 10L20 10"
            stroke="#fedd00"
            strokeWidth="1"
            strokeLinecap="round"
          />
          <path
            className={`transition-transform ${
              isMenuOpen
                ? "rotate-45  translate-x-[0.45rem] -translate-y-[0.18rem]"
                : ""
            }`}
            d="M4 6L20 6"
            stroke="#fedd00"
            strokeWidth="1"
            strokeLinecap="round"
          />
        </svg>

        {/* DESKTOP NAV LINKS------------------------------------------------------------ */}
        <div className=" flex-row space-x-8 text-[#fedd00] font-brandonGrotesque font-medium text-[22px] mr-10 x904:flex xs:hidden">
          <Link to="/#about-us">
            {" "}
            <p className=" cursor-pointer">ABOUT US</p>
          </Link>
          <Link to="/#flavours">
            {" "}
            <p className=" cursor-pointer">FLAVOURS</p>
          </Link>
          <Link to="/#where-to-buy">
            {" "}
            <p className=" cursor-pointer">WHERE TO BUY</p>
          </Link>
        </div>

        {/* Overlay Mobile-------------------------------------------------------------- */}
        <div
          className={`fixed top-0 left-0 w-full h-[100vh] bg-[#6e0001]  z-10 xs:flex justify-center items-center text-center x904:hidden transition-transform duration-[400ms] ease-in  ${
            isMenuOpen ? "translate-y-0" : "-translate-y-full"
          } `}
        >
          {/* Navigation links */}
          <div className="flex flex-col space-y-4 text-[#fee42d] font-brandonGrotesque font-medium text-2xl">
            <Link to="/#about-us">
              {" "}
              <p className="cursor-pointer">ABOUT US</p>
            </Link>
            <Link to="/#flavours">
              {" "}
              <p className=" cursor-pointer">FLAVOURS</p>
            </Link>
            <Link to="/#where-to-buy">
              {" "}
              <p className="cursor-pointer">WHERE TO BUY</p>
            </Link>
            {/* <p onClick={toggleMenu} className="cursor-pointer">
              CONTACT US
            </p> */}
          </div>
        </div>
      </div>
      {/* Navigation bar closed ///////////////////////////////////////////////////////////////////////////////*/}

      <div className="bg-[#670001] h-full text-center">
        <div
          className="bg-[#670001] relative overflow-hidden text-center x904:h-[66vh] xs:h-[55vh] x904:min-h-[750px] md:min-h-[680px]  mob2:min-h-[630px] xs:min-h-[530px]"
          style={{
            backgroundImage: `url(${contactImage})`,
            backgroundPosition: "top center", // Ensures the bottom part is always visible
            backgroundSize: "cover", // Keeps the aspect ratio while covering the div
          }}
        >
          {/* PLACE Form here!----------------------------------------------------------- */}
          <div className="  mx-4 md:mt-32 sms:mt-20 sm:mt-20 mob:mt-20 xs:mt-20 mb-20 flex justify-center items-center   relative">
            <div className="flex-1  xs:text-center  x904:mt-14 ">
              <div className=" mx-auto  xs:w-[100%]  text-[#fee42d] my-[0]   leading-[1.4] font-brandonGrotesque">
                <h2 className="x904:text-[2rem] md:text-[2rem] md2:text-[2rem] sms:text-[2rem] sm:text-[2rem] mob2:text-[2rem] xs:text-[2rem] my-20">
                  CONTACT US
                </h2>
                <p className=" font-brandonGrotesqueMd  x904:text-[2rem] md:text-[2rem] md2:text-[2rem] sms:text-[2rem] sm:text-[1.8rem] mob2:text-[1.8rem] xs:text-[1.32rem]  mx-auto x904:max-w-[430px]  sms:max-w-[430px] xs:max-w-[400px]">
                  Get in touch with us by emailing
                  <br />
                  <a
                    href="mailto:consumer.care@suntory.com"
                    className="underline text-inherit underline-offset-8 decoration-2 "
                  >
                    consumer.care@suntory.com
                  </a>
                  <br />
                  or by phone at
                  <br />
                  <a
                    href="tel:08009170750"
                    className="text-inherit  underline underline-offset-8 decoration-2  "
                  >
                    0800 917 0750 (UK)
                  </a>
                  <br />
                  and
                  <br />
                  <a
                    href="tel:1 800 883 555"
                    className="underline text-inherit underline-offset-8 decoration-2 "
                  >
                    1 800 883 555 (ROI)
                  </a>
                </p>

                <br />
              </div>
            </div>
          </div>

          {/* Form closed ----------------------------------------------------------------------*/}
        </div>
        {/* FOOTER SECTION------------------------------------------------------------------- */}
        <div
          // className=" w-full bg-no-repeat bg-cover x904:h-[34vh] xs:h-[45vh] x904:min-h-[340px] xs:min-h-[491px] "
          className=" w-full bg-no-repeat bg-cover x904:h-[34vh] xs:h-[45vh] x904:min-h-[416px] xs:min-h-[506px] "
          style={{
            backgroundImage: `url(${footImage})`,
            backgroundPosition: "top center", // Ensures the bottom part is always visible
            backgroundSize: "cover", // Keeps the aspect ratio while covering the div
          }}
        >
          <div className=" flex justify-center ">
            <div className="max-w-[1440px]  w-full flex x904:items-center justify-between x904:flex-row xs:flex-col text-[#fee42d] my-[0] mx-12   font-medium  leading-tight font-brandonGrotesque text-center ">
              <div className="flex-1  xs:text-center  x904:mt-14 xs:mt-14">
                <div className=" mx-auto  xs:w-[100%]">
                  <h2 className="x904:text-[1.35rem] md:text-[1.35rem] md2:text-[1.35rem] sms:text-[1.35rem] sm:text-[1.35rem] mob2:text-[1.35rem] xs:text-[1.35rem] mb-4">
                    © 2025 SUNTORY LA CASERA
                  </h2>
                  <p className="x904:text-[0.9rem] md:text-[0.9rem] md2:text-[0.9rem] sms:text-[0.9rem] sm:text-[0.9rem] mob2:text-[0.9rem] xs:text-[0.9rem]  mx-auto x904:max-w-[594px] xs:max-w-[360px] mb-4">
                    Produced in Spain using ingredients of EU and non-EU origin.
                    <br className="x904:block xs:hidden" />
                    &nbsp;Distributed by Lucozade Ribena Suntory Limited under
                    the authority of Schweppes International Limited. La Casera
                    and the La Casera logo are registered trademarks of
                    Schweppes International Limited.
                  </p>
                  <img
                    src={drinkware}
                    alt="drinkware logo"
                    className="max-w-[191px] h-auto  mx-auto"
                  />
                  <br />
                </div>
              </div>
            </div>
          </div>

          {/* <div className="xs:pb-[10%]  x904:py-8  x990:w-[956px] x904:w-[850px] sms:w-[500px] max-w-[1440px] mx-auto grid x904:grid-cols-8 xs:grid-cols-3 gap-2 w-full  place-items-center  x990:text-[0.9rem] mob3:text-[0.7rem] xs:text-[0.6rem] font-bold text-[#fee42d] font-brandonGrotesque">
          
            <div className="  flex justify-center items-center  xs:row-start-1 x904:col-start-4  x904:col-end-6 xs:col-span-full x904:col-span-1  x904:my-0 xs:my-10 ">
              <img
                src={crack}
                alt="crack a la Cesera "
                className=" w-[143px] h-auto cursor-pointer"
              />
            </div>

     
            <div className="  text-center x904:col-start-1 ">
              <Link to="/Contact" className="cursor-pointer">
                CONTACT US
              </Link>
            </div>
            <div className="  text-center x904:col-start-2 cursor-pointer">
              COOKIES
            </div>
            <div className="  text-center x904:col-start-3 cursor-pointer">
              PRIVACY POLICY
            </div>

    
            <div className="  text-center x904:col-start-6 cursor-pointer">
              FACEBOOK
            </div>
            <div className="  text-center x904:col-start-7 cursor-pointer">
              INSTAGRAM
            </div>
            <div className="  text-center x904:col-start-8 cursor-pointer">
              YOUTUBE
            </div>
          </div> */}

          <div className="xs:pb-[10%]  x904:pb-8  x990:w-[476px] x904:w-[476px] sms:w-[500px] max-w-[1440px] mx-auto grid xs:grid-cols-3 gap-2 w-full  place-items-center  x990:text-[0.9rem] mob3:text-[0.8rem] xs:text-[0.7rem] font-bold text-[#fee42d] font-brandonGrotesque">
            {/* Image first on mobile, centered */}
            <div className="  flex justify-center items-center  xs:row-start-1  xs:col-span-full   xs:my-8 ">
              <img
                src={crack}
                alt="crack a la Cesera "
                className=" w-[143px] h-auto cursor-pointer"
              />
            </div>

            {/* First 3 text items */}
            <div className="  text-center col-start-2 ">
              <Link to="/Contact" className="cursor-pointer">
                CONTACT US
              </Link>
            </div>
            {/* <div className="  text-center cursor-pointer">COOKIES</div>
            <div className="  text-center cursor-pointer">PRIVACY POLICY</div> */}
          </div>
        </div>
        {/* FOOTER SECTION END------------------------------------------------------------------- */}
      </div>
    </div>
  );
};
export default Contact;
